// extracted by mini-css-extract-plugin
export default {"container":"Confirmation_container__V+uZ6","yellowAlertSpamTitle":"Confirmation_yellowAlertSpamTitle__lA5LN","yellowAlertSpam":"Confirmation_yellowAlertSpam__lmRez"};